/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-01-03 13:22:03
 * @LastEditors: dongjing
 * @LastEditTime: 2020-02-14 10:09:13
 */
import Quill from 'quill';
import { APIS } from '@src/services';
import { message } from 'antd';
import { randomStr, file2base64, maxSize } from './utils';

export default class ImageDropAndPaste {
  public quill: Quill;

  public constructor(quill: Quill) {
    this.quill = quill;
    this.quill.root.addEventListener('paste', this.handlePaste, false);
  }

  public handlePaste = (e: ClipboardEvent) => {
    const { clipboardData } = e;
    const files = clipboardData ? Array.from(clipboardData.files) : [];

    if (files.length > 0) {
      e.preventDefault();
      files.forEach(async item => {
        if (item.size > maxSize.size) {
          message.error(maxSize.message);
          return;
        }

        const base64Url = await file2base64(item).then(res => {
          return res;
        });
        const { quill } = this;
        const range = quill.getSelection();
        const index = range ? range.index : quill.getLength();
        const id = randomStr();

        quill.insertEmbed(index, 'img', { src: base64Url, id }, 'user');
        APIS.FileApi.fileBase64UsingPost(base64Url).then(res => {
          const img = document.getElementById(id) as HTMLImageElement | null;
          if (img && res.code === 0 && res.result) {
            img.src = res.result.previewUrl || '';
          }
        });
      });
    }
  };
}
